import { Skeleton, Tabs } from "antd";
import { useIntl } from "react-intl";
import { UploadImageForm } from "~components/Images";
import { ImageBaseTypes } from "~enums/imageBaseTypes";
import { ImageTypes } from "~enums/imageTypes.ts";
import { PermissionNames } from "~enums/permissions.ts";
import type { Person } from "~types/person.ts";

type Props = {
  data?: Person;
  isLoading: boolean;
};

export const ManagePersonPhoto = ({ data, isLoading }: Props) => {
  const { formatMessage } = useIntl();

  if (isLoading || !data) return <Skeleton.Input active block style={{ width: 350, height: 480 }} />;

  const items = [
    {
      key: "head",
      label: formatMessage({ id: "add.photo.PERSON.PERSON_HEAD" }),
      children: (
        <UploadImageForm
          imageType={ImageTypes.PersonHead}
          baseId={data.personId}
          images={data?.images}
          baseType={ImageBaseTypes.Person}
          permissionKey={PermissionNames.PERSON}
        />
      ),
    },
    {
      key: "waist",
      label: formatMessage({ id: "add.photo.PERSON.PERSON_WAIST" }),
      children: (
        <UploadImageForm
          imageType={ImageTypes.PersonWaist}
          baseId={data.personId}
          images={data?.images}
          baseType={ImageBaseTypes.Person}
          permissionKey={PermissionNames.PERSON}
        />
      ),
    },
    {
      key: "posed",
      label: formatMessage({ id: "add.photo.PERSON.PERSON_POSE" }),
      children: (
        <UploadImageForm
          imageType={ImageTypes.PersonPose}
          baseId={data.personId}
          images={data?.images}
          baseType={ImageBaseTypes.Person}
          permissionKey={PermissionNames.PERSON}
        />
      ),
    },
  ];

  return (
    <div className="card-container tabs-wrap">
      <Tabs tabBarGutter={0} items={items} />
    </div>
  );
};
